import { render, staticRenderFns } from "./custosVariaveisEditar.vue?vue&type=template&id=a9a5c61e&scoped=true&"
import script from "./custosVariaveisEditar.vue?vue&type=script&lang=js&"
export * from "./custosVariaveisEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a5c61e",
  null
  
)

export default component.exports